import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { CtExamAttachAdd, CtExamTemplateReceiveTest } from 'containers';

import * as commonVar from 'libs/commonVar';

import classNames from 'classnames/bind';
import styles from './ExamAttachMenu.css';
const cx = classNames.bind(styles);

// 첨부파일 상단의 버튼 영역
class ExamAttachMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isAuth } = this.props;

    return (
      <div className={cx('func-list')}>
        {/* 첨부파일 등록 버튼 */}
        {commonVar.isSaas === 1 && <CtExamAttachAdd />}
      </div>
    );
  }
}

ExamAttachMenu.propTypes = {
  //
};
ExamAttachMenu.defaultProps = {
  //
};

const mapStateToProps = (state, props) => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

export default connect(mapStateToProps)(ExamAttachMenu);



// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachMenu.js